import { createAction } from 'redux-actions';
import { DOC24_FEED_PRACTITIONER_DATA } from '../../constants';
import { responseEnd, responseWait } from '../common/loadingActions';
import { store } from '../../store';
import Doc24Service from '../../services/doc24';
import { CLIENT } from '../../constants/doc24';

const createSessionDOC24 =
  ({ practitionerId, email, client = CLIENT.MEDICAL_POINT }) =>
  async () => {
    store.dispatch(responseWait());
    try {
      await Doc24Service.createSessionDOC24(practitionerId, email, client);
    } catch (e) {
    } finally {
      store.dispatch(responseEnd());
    }
  };

export const createSessionDOC24Action = createAction(DOC24_FEED_PRACTITIONER_DATA, (payload) =>
  createSessionDOC24(payload)(),
);
